export const calculateToHit = (character) => {

  const charClass = character.chars.myClass

  if ( ['Fighter', 'F/', 'Paladin', 'Ranger'].some(str => charClass.includes(str))) {

    return 0 }

  if ( ['Cleric', 'Cl', 'Druid', 'Dr', 'Monk'].some(str => charClass.includes(str))) {
    return 0 }
    
  return -1

}